import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageService } from 'src/app/shared/storage/storage.service';

const KEY_DRIVER = 'driver';

@Component({
    selector: 'app-dqf-driver-emergency-contact',
    templateUrl: './dqf-driver-emergency-contact.component.html',
    styleUrls: ['./dqf-driver-emergency-contact.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class DqfDriverEmergencyContactComponent implements OnInit {
  @Input() driverVersionDetails: any;
  data = [];
  isLoading = true;
  constructor(private storageService: StorageService) {}

  ngOnInit(): void {
    this.getDriver();
  }

  private getDriver(): void {
    // Simulate API loading delay
    setTimeout(() => {
      const driver = this.driverVersionDetails ?? this.storageService.find(KEY_DRIVER);
      if (!driver) {
        this.isLoading = false;
        return;
      }
      
      const emergencyContact = driver.emergencyContacts;
      if (emergencyContact && Array.isArray(emergencyContact)) {
        emergencyContact.forEach((contact, index) => {
          if (contact) {
            this.data.push({
              contactNumber: index + 1,
              contactData: [
                {
                  propertyName: 'Name',
                  propertyValue: `${contact.emergencyContactName || ''}`
                },
                { propertyName: 'Relation', propertyValue: `${contact.emergencyContactRelation || ''}` },
                { propertyName: 'Phone', propertyValue: `${contact.emergencyContactPhone || ''}` }
              ]
            });
          }
        });
      }
      this.isLoading = false;
    }, 100);
  }
}
